/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_ConflictInputs */

const es_co2_error_conflict = /** @type {(inputs: Error_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguien más modificó esto mientras lo editabas. Recarga la página e intenta de nuevo.`)
};

/**

* @param {Error_ConflictInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_conflict = /** @type {((inputs?: Error_ConflictInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_ConflictInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_conflict(inputs)
});